import m from "../../geodata/es2015/brazilHigh";
window.am4geodata_brazilHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/brazilHigh.js
// module id = null
// module chunks = 